<template>
    <div>
        <slot
            v-bind="{
                updatePaymentMethod,
                cardProcessing,
            }"
        />
    </div>
</template>

<script>
import toasts from '@/mixins/toasts';
import apiCall from '@/utils/apiCall';
import getActiveSubscription from '@/utils/getActiveSubscription';
import { mapMutations, mapActions, mapState } from 'vuex';

export default {
    mixins: [toasts],

    props: {
        withoutSubscription: {
            type: Boolean,
            default: false,
        },
    },

    data: () => ({
        cardProcessing: false,
    }),

    computed: {
        ...mapState(['user', 'userSubscription']),
    },

    methods: {
        ...mapMutations(['changeUIState']),
        ...mapActions(['reloadPaymentMethods']),

        /**
         * Updates pro user payment method
         *
         * @param { string } payment_method Stripe payment method.
         */
        async updatePaymentMethod(payment_method) {
            const { status } = await apiCall(this, 'post', '/api/billing/payments/methods', { payment_method });

            if (200 !== status) {
                this.updateError();
            }

            if (this.withoutSubscription && 200 === status) {
                this.$emit('update-without-subscription-finished');
                this.updateSuccess();
            } else {
                this.cardProcessing = true;

                this.updateUserSubscription(payment_method)
                    .then(() => {
                        this.reloadPaymentMethods();
                        this.updateSuccess();
                    })
                    .catch((e) => {
                        this.updateError();
                    });
            }
        },

        /**
         * Updates user subscription
         *
         * @param {string} payment_method Stripe payment method.
         * @returns {Promise} Update subscription API call.
         */
        async updateUserSubscription(payment_method) {
            const subscription = getActiveSubscription(this.user.subscriptions);

            return apiCall(this, 'put', `/api/billing/subscriptions/${subscription.id}`, {
                payment_method,
            });
        },

        /**
         * Handle update success
         *
         */
        updateSuccess() {
            this.toastSuccess({
                message: {
                    title: 'Your Payment Method has been updated',
                },
            });

            this.$emit('update-finished');
        },

        /**
         * Handle update error
         *
         */
        updateError() {
            this.cardProcessing = false;

            this.toastError({
                message: {
                    title: 'An error occured, we couldn\'t update your payment method',
                },
            });
        },

    },
};
</script>
